export const SEND_CONNECTION_EMAILS_TEXT = { id: 'oe.templates.connectionEmails.send', defaultMessage: 'Send' };

export const YES_SEND = {
    id: 'oe.templates.connectionEmails.yesSend',
    defaultMessage: 'Yes, Send'
};

export const TO_TEXT = {
    id: 'oe.templates.common.to',
    defaultMessage: 'To'
};

export const REPLY_TO_TEXT = {
    id: 'oe.templates.common.replyTo',
    defaultMessage: 'Reply to'
};

export const CC_TEXT = {
    id: 'oe.templates.common.cc',
    defaultMessage: 'CC'
};

export const BCC_TEXT = {
    id: 'oe.templates.common.bcc',
    defaultMessage: 'BCC'
};

export const EMAIL_SENT_SUCCESSFULLY = {
    id: 'oe.templates.connectionEmails.emailSentSuccessfully',
    defaultMessage: 'Email sent successfully'
};
